import React, { useEffect, useRef }  from 'react';
import classes from './FeaturedPromo.module.scss';
import { getFileName } from 'helpers/FileCaching';
import globalJson from 'data/content.json';
import ScrollMagic from 'scrollmagic';
import TimelineMax from "gsap/TimelineMax";
import {TweenMax, Power3, Power2} from 'gsap';

const promosImages = require.context('assets/images/FeaturedPromo', true, /.*\.(gif|png|jpe?g|svg)$/i);
const iconsImages = require.context('assets/images/global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);
const FeaturedPromo = ({carRef, history}) => {

    //Timeline variables
    let container = useRef();
    let featured = useRef();
    let btnFeaturedOnHover = useRef();
    let btnFeaturedArrowOnHover = useRef();
    let btnFeaturedOvalOnHover = useRef();
    let featuredImage = useRef();

    //Configure scroll magic
    let scrollMagicController = useRef(new ScrollMagic.Controller())
    let scrollMagicScene = useRef(new ScrollMagic.Scene({
                                    triggerHook:0.7
                                }).addTo(scrollMagicController.current)
                            )

    let showAll_tl = useRef(new TimelineMax({paused:true}));
    showAll_tl.current.timeScale(2);

    useEffect(() => {
        const configureScrollMagic = () => {
            scrollMagicScene.current.triggerElement(container.current);
            scrollMagicScene.current.duration((container.current.clientHeight));
            scrollMagicScene.current.triggerHook(0.7);
            scrollMagicScene.current.on("progress", function(event){
                updateTimeline(event.progress);
            })
        }

        configureScrollMagic();
    }, []);
    useEffect(() => {
        const createTimeline = () => {
            showAll_tl.current.fromTo(featured.current, 3, {delay: - 0.5, opacity:0, y:90},{opacity:1, y:0, ease: Power2.easeInOut});
        }

        createTimeline();
    }, []);
    const updateTimeline = (progress) => {
        let timelineLength = showAll_tl.current.duration();
        let tweenToSeconds = timelineLength*progress
        showAll_tl.current.tweenTo(tweenToSeconds);
    }

    const onPromoClick = (title) =>{
        window.gtag('event', "Episode clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': title+ " Episode clicked",
			'value':10
          });
    }

    const goToArticle = (url) => {
        history.push(url)
    }
  

    function overFeatured(e){
        TweenMax.fromTo(btnFeaturedOvalOnHover.current, 0.2, {scale:1}, { delay: 0, scale:0.7, ease: Power3.easeInOut});
        TweenMax.fromTo( btnFeaturedArrowOnHover.current, 0.2, {css:{height:0, width: 0}}, { delay: 0, css:{height:30, width: 30}, ease: Power3.easeInOut});
    }
    function outFeatured(e){
        TweenMax.to(btnFeaturedOvalOnHover.current, 0.2, {scale:1, ease: Power3.easeInOut})
        TweenMax.to( btnFeaturedArrowOnHover.current, 0.2, {css:{height:0, width: 0}, ease: Power3.easeInOut})
    }
    
    return(
        <div className={classes.FeaturedPromo }>
            <div className={`${classes.FeaturedPromo__bg}`}></div>
            <div className={`${classes.FeaturedPromo__container} `} ref={container}>
                <div ref={carRef}>
                    <div className={classes.FeaturedPromo__featuredMainLink}>
                        <div ref={featured} className={`row ${classes.FeaturedPromo__featuredPromo}`}>
                            <div ref={featuredImage} onClick={(event) =>{ onPromoClick(globalJson.featuredPromo.title); goToArticle(globalJson.featuredPromo.url);}} className={`col-lg-8 ${classes.FeaturedPromo__featuredPromoImage}`}
                                style={
                                    {
                                        backgroundImage: 'url(' + getFileName(promosImages, globalJson.featuredPromo.image) + ')'
                                    }
                                } onMouseOver={overFeatured} onMouseOut={outFeatured}>
                            </div>
                            <div className={`col-lg-4 ${classes.FeaturedPromo__featuredPromoContent}`}>                
                                <p  onClick={(event) =>{ onPromoClick(globalJson.featuredPromo.title); goToArticle(globalJson.featuredPromo.url);}} className={`subtitle ${classes.FeaturedPromo__featuredPromoSubtitle}`} onMouseOver={overFeatured} onMouseOut={outFeatured}>{globalJson.featuredPromo.subtitle}</p>
                                <h3  onClick={(event) =>{ onPromoClick(globalJson.featuredPromo.title); goToArticle(globalJson.featuredPromo.url);}} className={classes.FeaturedPromo__featuredPromoTitle} onMouseOver={overFeatured} onMouseOut={outFeatured}>{globalJson.featuredPromo.title} </h3>
                                <p  onClick={(event) =>{ onPromoClick(globalJson.featuredPromo.title); goToArticle(globalJson.featuredPromo.url);}} className={`global_description ${classes.FeaturedPromo__featuredPromoDescription}`} onMouseOver={overFeatured} onMouseOut={outFeatured}>{globalJson.featuredPromo.description}</p>
                            </div>
                            <div ref={btnFeaturedOnHover}  onClick={(event) =>{ onPromoClick(globalJson.featuredPromo.title); goToArticle(globalJson.featuredPromo.url);}} className={`arrowCta arrowCtaLight ${classes.FeaturedPromo__featuredPromoCta}`} onMouseOver={overFeatured} onMouseOut={outFeatured}>
                                <div className={classes.FeaturedPromo__featuredCtaWrapper}>
                                    {globalJson.featuredPromo.cta}
                                    <span className={`arrowCta__iconWrapper`}>
                                        <span ref={btnFeaturedArrowOnHover} className={`arrowCta__onHover`}></span>
                                        <img ref={btnFeaturedOvalOnHover} className={`arrowCta__oval`} alt="play icon border" src={getFileName(iconsImages, 'ovalArrow.svg')}/>
                                        <img  className={`arrowCta__arrow`} alt="play icon" src={getFileName(iconsImages, 'nextArrow.svg')}/>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            
    
    );
};
export default FeaturedPromo;